import { $CombinedState, AnyAction, applyMiddleware, compose, createStore, Middleware, Store } from 'redux';
import { Action } from './actions/actions';
import rootReducer, { StateTree } from './reducers';
import rootSaga from './reducers/sagas';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}

function configureStore(
  initialState: StateTree,
  sagaMiddleware: any,
): Store<
  {
    readonly [$CombinedState]?: undefined;
  } & StateTree,
  AnyAction
> {
  const actionSanitizer = (action: Action) =>
    action.type === 'STORE_IMPACT_SCORES' ? { ...action, payload: '<<LONG_BLOB>>' } : action;
  const stateSanitizer = (state: StateTree) =>
    state.data.impactScoresByPIVV
      ? {
          ...state,
          data: { ...state.data, impactScoresByPIVV: '<<TOO_BIG_TO_DEBUG>>' },
        }
      : state;

  const composeEnhancers =
    (process.env.NODE_ENV !== 'production' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionSanitizer,
        stateSanitizer,
      })) ||
    compose;
  const middleware: Middleware[] = [];
  middleware.push(sagaMiddleware);
  const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));
  sagaMiddleware.run(rootSaga);

  return store;
}

export default configureStore;
